import BootstrapModal from 'react-bootstrap/Modal';
import styles from './style.module.scss';

type ModalProps = {
  open: boolean;
  title?: string;
  dialogClassName?: string;
  containerClassName?: string;
  onClose: () => void;
  isCloseIconVisible?: boolean;
  children: React.ReactNode;
  width?: number;
  modalTitleClassName?: string;
};

const Modal = ({
  open,
  title,
  onClose,
  isCloseIconVisible = true,
  children,
  dialogClassName = '',
  containerClassName = '',
  modalTitleClassName,
  width = 600,
}: ModalProps) => {
  return (
    <BootstrapModal
      show={open}
      backdrop={isCloseIconVisible ? true : 'static'}
      onHide={onClose}
      animation={false}
      centered
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName={`justify-content-center ${styles.modal} ${dialogClassName}`}
      contentClassName="w-100"
    >
      <div
        className={`${styles.content} ${containerClassName} `}
        // style={{ width: '100%', maxWidth: `${width}px` }}
      >
        <BootstrapModal.Header
          closeButton={isCloseIconVisible}
          className="p-0 border-0"
        >
          {title && (
            <BootstrapModal.Title
              id="contained-modal-title-vcenter"
              className={`font-source-sans fw-bold ${modalTitleClassName}`}
            >
              {title}
            </BootstrapModal.Title>
          )}
        </BootstrapModal.Header>
        <BootstrapModal.Body className="p-0 mt-3 font-source-sans">
          {children}
        </BootstrapModal.Body>
      </div>
    </BootstrapModal>
  );
};

export default Modal;
